import {createConfig as createBestReviewsConfig} from './bestreviews/config'
import {createConfig as createBestReviewsGuideConfig} from './bestreviews-clone/config'
import {createConfig as createTheBestReviewsConfig} from './thebestreviews/config'
import {createConfig as createBestHouseholdPicksConfig} from './besthouseholdpicks/config'
import {createConfig as createBestHouseholdPicksCloneConfig} from './besthouseholdpicks-clone/config'
import {createConfig as createComparerMieuxConfig} from './comparermieux/config'
import {createConfig as createTheBestKitchenPicksConfig} from './thebestkitchenpicks/config'
import {createConfig as createBestSportsGearPicksConfig} from './bestsportsgearpicks/config'
import {createConfig as createEagleReviewsConfig} from './eaglereviews/config'
import {createConfig as createTopOnlineReviewsConfig} from './toponlinereviews/config'
import {createConfig as createBestGardenPicksConfig} from './bestgardenpicks/config'
import {createConfig as createOfficeGearPicksConfig} from './officegearpicks/config'
import {createConfig as createBestHomeFixPicksConfig} from './besthomefixpicks/config'
import {createConfig as createBestOutdoorGearPicksConfig} from './bestoutdoorgearpicks/config'
import {createConfig as createBestPetEssentialsPicksConfig} from './bestpetessentialspicks/config'
import {createConfig as createBestDiyToolPicksConfig} from './bestdiytoolpicks/config'
import {createConfig as createBestPersonalCarePicksConfig} from './bestpersonalcarepicks/config'
import {createConfig as createBestTechGearPicksConfig} from './besttechgearpicks/config'
import {createConfig as createBestReviewsOnlineConfig} from './bestreviewsonline/config'
import {createConfig as createBestHomeCleaningPicksConfig} from './besthomecleaningpicks/config'
import {createConfig as createBestHomeClimatePicksConfig} from './besthomeclimatepicks/config'
import {createConfig as createBestExpertsChoiceConfig} from './bestexpertschoice/config'
import {createConfig as createHomeClimateInsiderConfig} from './homeclimateinsider/config'
import {createConfig as createBestMobilePicksConfig} from './bestmobilepicks/config'
import {createConfig as createGharKeBestPicksConfig} from './gharkebestpicks/config'
import {createConfig as createTheBestTechPicksConfig} from './thebesttechpicks/config'
import {createConfig as createAmericanBest10Config} from './americanbest10/config'
import {createConfig as createTopStatesReviewsConfig} from './topstatesreviews/config'
import {createConfig as createBestPatrioticPicksConfig} from './bestpatrioticpicks/config'
import {createConfig as createTopExpertsChoiceConfig} from './topexpertschoice/config'
import {createConfig as createBestOnlinePicksConfig} from './bestonlinepicks/config'
import {createConfig as createTopHomeProductReviewsConfig} from './tophomeproductreviews/config'
import {createConfig as createTopTechProductReviewsConfig} from './toptechproductreviews/config'
import {createConfig as createTopPersonalProductReviewsConfig} from './toppersonalproductreviews/config'
import {createConfig as createTopOutdoorProductReviewsConfig} from './topoutdoorproductreviews/config'
import {createConfig as createTopReviewedProductsConfig} from './topreviewedproducts/config'
import {createConfig as createBestStaubsaugerConfig} from './bestestaubsauger/config'
import {createConfig as createBesteExpertenwahlConfig} from './besteexpertenwahl/config'
import {createConfig as createAirPurifiersInsiderConfig} from './airpurifiersinsider/config'
import {createConfig as createDehumidifiersInsiderConfig} from './dehumidifiersinsider/config'
import {createConfig as createHandToolsInsiderConfig} from './handtoolsinsider/config'
import {createConfig as createHomeEssentialsInsiderConfig} from './homeessentialsinsider/config'
import {createConfig as createOutdoorsGearInsiderConfig} from './outdoorsgearinsider/config'
import {createConfig as createRobotVacuumsInsiderConfig} from './robotvacuumsinsider/config'
import {createConfig as createTheMobileInsiderConfig} from './themobileinsider/config'
import {createConfig as createTechGearInsiderConfig} from './techgearinsider/config'
import {createConfig as createChoixExpertConfig} from './choixexpert/config'
import {createConfig as createMeilleursTestsConfig} from './meilleurstests/config'
import {createConfig as createProduitsTopConfig} from './produitstop/config'
import {createConfig as createAvisOutdoorConfig} from './avisoutdoor/config'
import {createConfig as createAvisHightechConfig} from './avishightech/config'
import {createConfig as createSelectionTopConfig} from './selectiontop/config'
import {createConfig as createAvisMaisonConfig} from './avismaison/config'
import {createConfig as createCanadaTopPicksConfig} from './canadatoppicks/config'
import {createConfig as createCanadaBest10Config} from './canadabest10/config'
import {createConfig as createOzzieChoiceReviewsConfig} from './ozziechoicereviews/config'
import {createConfig as createBestOnlineReviewsConfig} from './bestonlinereviews/config'
import {createConfig as createTop10WorthItConfig} from './top10worthit/config'
import {createConfig as createBestValueRankingsConfig} from './bestvaluerankings/config'
import {createConfig as createTopProduktVergleichConfig} from './topproduktvergleich/config'
import {createConfig as createExpertenReviewsConfig} from './expertenreviews/config'
import {createConfig as createTopReviews24Config} from './topreviews24/config'
import {createConfig as createBestMotorGearPicksConfig} from './bestmotorgearpicks/config'
import {createConfig as createBestCarGearPicksConfig} from './bestcargearpicks/config'
import {createConfig as createDiyToolBestPicksConfig} from './diytoolbestpicks/config'
import {createConfig as createExpertStopChoiceConfig} from './expertstopchoice/config'
import {createConfig as createExpertStopChoicesConfig} from './expertstopchoices/config'
import {createConfig as createHouseholdBestPicksConfig} from './householdbestpicks/config'
import {createConfig as createKitchenTopPicksConfig} from './kitchentoppicks/config'
import {createConfig as createSportsGearBestPicksConfig} from './sportsgearbestpicks/config'
import {createConfig as createTechGearAdvisorsConfig} from './techgearadvisors/config'
import {createConfig as createValueFirstChoicesConfig} from './valuefirstchoices/config'
import {createConfig as createMyPoundSaverConfig} from './mypoundsaver/config'
import {createConfig as createBestPetSuppliesPicksConfig} from './bestpetsuppliespicks/config'
import {createConfig as createGardenBestPicksConfig} from './gardenbestpicks/config'
import {createConfig as createGreatReviewsOnlineConfig} from './greatreviewsonline/config'
import {createConfig as createTechGearReviewedConfig} from './techgearreviewed/config'
import {createConfig as createTopMotorGearChoiceConfig} from './topmotorgearchoice/config'
import {createConfig as createIntBestReviewsConfig} from './intbestreviews/config'
import {createConfig as createWiseCompareConfig} from './wisecompare/config'
import {createConfig as createBestProductsChoicesConfig} from './bestproductschoices/config'

export const DOMAIN_CONFIG_BY_HOSTNAME = {
  // ===== BEST REVIEWS GUIDE =====
  'www.bestreviews.guide': createBestReviewsConfig, // US
  'the.bestreviews.guide': createTheBestReviewsConfig, // US
  'de.bestreviews.guide': createBestReviewsConfig, // DE
  'it.bestreviews.guide': createBestReviewsConfig, // IT
  'fr.bestreviews.guide': createBestReviewsConfig, // FR
  'es.bestreviews.guide': createBestReviewsConfig, // ES
  'au.bestreviews.guide': createBestReviewsConfig, // AU

  'us.bestreviews.guide': createBestReviewsGuideConfig, // US

  // ===== INT. BEST REVIEWS GUIDE =====
  'int.bestreviews.guide': createIntBestReviewsConfig, // US
  // ===== AIR PURIFIERS INSIDER =====
  'www.airpurifiersinsider.com': createAirPurifiersInsiderConfig, // US

  // ===== DEHUMIDIFIERS INSIDER =====
  'www.dehumidifiersinsider.com': createDehumidifiersInsiderConfig, // US

  // ===== HAND TOOLS INSIDER =====
  'www.handtoolsinsider.com': createHandToolsInsiderConfig, // US

  // ===== HOME ESSENTIALS INSIDER =====
  'www.homeessentialsinsider.com': createHomeEssentialsInsiderConfig, // US

  // ===== OUTDOORS GEAR INSIDER =====
  'www.outdoorsgearinsider.com': createOutdoorsGearInsiderConfig, // US

  // ===== ROBOT VACUUMS INSIDER =====
  'www.robotvacuumsinsider.com': createRobotVacuumsInsiderConfig, // US

  // ===== THE MOBILE INSIDER =====
  'www.themobileinsider.com': createTheMobileInsiderConfig, // US

  // ===== TECH GEAR INSIDER =====
  'www.techgearinsider.com': createTechGearInsiderConfig, // US
  'www.techgearinsider.in': createTechGearInsiderConfig, // IN

  // ===== TECH GEAR REVIEWED =====
  'www.techgearreviewed.com': createTechGearReviewedConfig, // US
  // ===== BEST HOUSEHOLD PICKS =====
  'www.besthouseholdpicks.com': createBestHouseholdPicksConfig, // US
  'www.besthouseholdpicks.co.uk': createBestHouseholdPicksConfig, // UK

  'us.besthouseholdpicks.com': createBestHouseholdPicksCloneConfig, // US

  // ===== COMPARER MIEUX =====
  'www.comparermieux.fr': createComparerMieuxConfig, // FR

  // ===== THE BEST KITCHEN PICKS =====
  'www.thebestkitchenpicks.com': createTheBestKitchenPicksConfig, // US

  // ===== BEST SPORTS GEAR PICKS =====
  'www.bestsportsgearpicks.com': createBestSportsGearPicksConfig, // US

  // ===== EAGLE REVIEWS =====
  'www.eagle-reviews.com': createEagleReviewsConfig, // US

  // ===== TOP ONLINE REVIEWS =====
  'www.toponlinereviews.co.uk': createTopOnlineReviewsConfig, // UK
  'www.toponlinereviews.ca': createTopOnlineReviewsConfig, // CA

  // ===== BEST GARDEN PICKS =====
  'www.bestgardenpicks.com': createBestGardenPicksConfig, // US

  // ===== BEST OUTDOOR GEAR PICKS =====
  'www.bestoutdoorgearpicks.com': createBestOutdoorGearPicksConfig, // US

  // ===== BEST OFFICE GEAR PICKS =====
  'www.officegearpicks.com': createOfficeGearPicksConfig, // US

  // ===== BEST HOME FIX PICKS =====
  'www.besthomefixpicks.com': createBestHomeFixPicksConfig, // US

  // ===== BEST DIY TOOL PICKS =====
  'www.bestdiytoolpicks.com': createBestDiyToolPicksConfig, // US

  // ===== BEST PET ESSENTIALS PICKS =====
  'www.bestpetessentialspicks.com': createBestPetEssentialsPicksConfig, // US

  // ===== BEST PERSONAL CARE PICKS =====
  'www.bestpersonalcarepicks.com': createBestPersonalCarePicksConfig, // US
  'www.bestpersonalcarepicks.co.uk': createBestPersonalCarePicksConfig, // UK

  // ===== BEST TECH GEAR PICKS =====
  'www.besttechgearpicks.co.uk': createBestTechGearPicksConfig, // UK

  // ===== THE BEST TECH PICKS =====
  'www.thebesttechpicks.com': createTheBestTechPicksConfig, // US

  // ===== BEST MOBILE PICKS =====
  'www.bestmobilepicks.com': createBestMobilePicksConfig, // US

  // ===== BEST REVIEWS ONLINE =====
  'www.bestreviewsonline.co.uk': createBestReviewsOnlineConfig, // UK
  'www.bestreviewsonline.ca': createBestReviewsOnlineConfig, // CA

  // ===== BEST ONLINE REVIEWS =====
  'www.bestonlinereviews.in': createBestOnlineReviewsConfig, // IN

  // ===== BEST HOME CLEANING PICKS =====
  'www.besthomecleaningpicks.com': createBestHomeCleaningPicksConfig, // US

  // ===== BEST HOME CLIMATE PICKS =====
  'www.besthomeclimatepicks.com': createBestHomeClimatePicksConfig, // US

  // ===== HOME CLIMATE INSIDER =====
  'www.homeclimateinsider.com': createHomeClimateInsiderConfig, // US

  // ===== BEST EXPERTS CHOICE =====
  'www.bestexpertschoice.com': createBestExpertsChoiceConfig, // US
  'www.bestexpertschoice.co.uk': createBestExpertsChoiceConfig, // UK
  'www.bestexpertschoice.ca': createBestExpertsChoiceConfig, // CA
  'www.bestexpertschoice.in': createBestExpertsChoiceConfig, // IN
  'shop.bestexpertschoice.au': createBestExpertsChoiceConfig, // AU

  // ===== TOP EXPERTS CHOICE =====
  'www.topexpertschoice.co.uk': createTopExpertsChoiceConfig, // UK
  'www.topexpertschoice.ca': createTopExpertsChoiceConfig, // CA

  // ===== GHAR KE BEST PICKS =====
  'www.gharkebestpicks.in': createGharKeBestPicksConfig, // IN

  // ===== AMERICAN BEST 10 =====
  'www.americanbest10.com': createAmericanBest10Config, // US

  // ===== TOP STATES REVIEWS =====
  'www.topstatesreviews.com': createTopStatesReviewsConfig, // US

  // ===== BEST PATRIOTIC PICKS =====
  'www.bestpatrioticpicks.com': createBestPatrioticPicksConfig, // US

  // ===== CANADA TOP PICKS =====
  'www.canadatoppicks.ca': createCanadaTopPicksConfig, // CA

  // ===== CANADA BEST 10 =====
  'www.canadabest10.ca': createCanadaBest10Config, // CA

  // ===== BEST ONLINE PICKS =====
  'www.bestonlinepicks.co.uk': createBestOnlinePicksConfig, // UK
  'www.bestonlinepicks.ca': createBestOnlinePicksConfig, // CA

  // ===== TOP HOME PRODUCT REVIEWS =====
  'www.tophomeproductreviews.co.uk': createTopHomeProductReviewsConfig, // UK
  'www.tophomeproductreviews.ca': createTopHomeProductReviewsConfig, // CA

  // ===== TOP TECH PRODUCT REVIEWS =====
  'www.toptechproductreviews.co.uk': createTopTechProductReviewsConfig, // UK
  'www.toptechproductreviews.ca': createTopTechProductReviewsConfig, // CA

  // ===== TOP PERSONAL PRODUCT REVIEWS =====
  'www.toppersonalproductreviews.co.uk': createTopPersonalProductReviewsConfig, // UK
  'www.toppersonalproductreviews.ca': createTopPersonalProductReviewsConfig, // CA

  // ===== TOP OUTDOOR PRODUCT REVIEWS =====
  'www.topoutdoorproductreviews.co.uk': createTopOutdoorProductReviewsConfig, // UK
  'www.topoutdoorproductreviews.ca': createTopOutdoorProductReviewsConfig, // CA

  // ===== TOP REVIEWED PRODUCTS =====
  'www.topreviewedproducts.co.uk': createTopReviewedProductsConfig, // UK
  'www.topreviewedproducts.ca': createTopReviewedProductsConfig, // CA

  // ===== BEST STAUBSAUGER =====
  'www.bestestaubsauger.de': createBestStaubsaugerConfig, // DE

  // ===== BESTE EXPERTENWAHL =====
  'www.besteexpertenwahl.de': createBesteExpertenwahlConfig, // DE

  // ===== CHOIX EXPERT =====
  'www.choixexpert.fr': createChoixExpertConfig, // FR

  // ===== MEILLEURS TESTS =====
  'www.meilleurstests.fr': createMeilleursTestsConfig, // FR

  // // ===== SELECTION TOP =====
  'www.selectiontop.fr': createSelectionTopConfig, // FR

  // ===== PRODUITS TOP =====
  'www.produitstop.fr': createProduitsTopConfig, // FR

  // // ===== AVI MAISON =====
  'www.avismaison.fr': createAvisMaisonConfig, // FR

  // // ===== AVI HIGH TECH =====
  'www.avishightech.fr': createAvisHightechConfig, // FR

  // ===== AVIS OUTDOOR =====
  'www.avisoutdoor.fr': createAvisOutdoorConfig, // FR

  // ===== OZZIE CHOICE REVIEWS =====
  'www.ozziechoicereviews.au': createOzzieChoiceReviewsConfig, // AU

  // ===== TOP 10 WORTH IT =====
  'www.top10worthit.com': createTop10WorthItConfig, // US

  // ===== BEST VALUE RANKINGS =====
  'www.bestvaluerankings.com': createBestValueRankingsConfig, // US

  // ===== TOP PRODUKT VERGLEICH =====
  'de.top-produkt-vergleich.com': createTopProduktVergleichConfig, // DE

  // ===== EXPERTEN REVIEWS =====
  'www.experten-reviews.de': createExpertenReviewsConfig, // DE

  // ===== TOP REVIEWS 24 =====
  'www.topreviews24.de': createTopReviews24Config, // DE

  // ===== BEST MOTOR GEAR PICKS =====
  'www.bestmotorgearpicks.com': createBestMotorGearPicksConfig, // US

  // ===== TOP MOTOR GEAR CHOICE =====
  'www.topmotorgearchoice.com': createTopMotorGearChoiceConfig, // US

  // ===== BEST CAR GEAR PICKS =====
  'www.bestcargearpicks.com': createBestCarGearPicksConfig, // US

  // ===== DIY TOOL BEST PICKS =====
  'www.diytoolbestpicks.com': createDiyToolBestPicksConfig, // US

  // ===== EXPERTS TOP CHOICE =====
  'www.expertstopchoice.com': createExpertStopChoiceConfig, // US
  'www.expertstopchoice.ca': createExpertStopChoiceConfig, // CA

  // ===== EXPERTS TOP CHOICES =====
  'www.expertstopchoices.com': createExpertStopChoicesConfig, // US
  // ===== HOUSEHOLD BEST PICKS =====
  'www.householdbestpicks.com': createHouseholdBestPicksConfig, // US

  // ===== KITCHEN TOP PICKS =====
  'www.kitchentoppicks.com': createKitchenTopPicksConfig, // US

  // ===== SPORTS GEAR BEST PICKS =====
  'www.sportsgearbestpicks.com': createSportsGearBestPicksConfig, // US

  // ===== TECH GEAR ADVISORS =====
  'www.techgearadvisors.com': createTechGearAdvisorsConfig, // US

  // ===== VALUE FIRST CHOICES =====
  'www.valuefirstchoices.com': createValueFirstChoicesConfig, // US

  // ===== MY POUND SAVER =====
  'www.mypoundsaver.co.uk': createMyPoundSaverConfig, // UK
  // ===== WISE COMPARE =====

  'www.wisecompare.co.uk': createWiseCompareConfig, // UK
  // ===== BEST PET SUPPLIES PICKS =====
  'www.bestpetsuppliespicks.com': createBestPetSuppliesPicksConfig, // US

  // ===== GARDEN BEST PICKS =====
  'www.gardenbestpicks.com': createGardenBestPicksConfig, // US

  // ===== GREAT REVIEWS ONLINE =====
  'www.greatreviewsonline.com': createGreatReviewsOnlineConfig, // US
  'www.greatreviewsonline.ca': createGreatReviewsOnlineConfig, // CA

  // ===== BEST PRODUCTS CHOICES =====
  'www.bestproductschoices.com': createBestProductsChoicesConfig, // US
} as const
